import Vue from 'vue'
import store from '@/store'

Vue.directive('check-admin-permission', {
  inserted(el, binding, node) {
    const permissions = Array.isArray(binding.value) ? binding.value : [binding.value]
    if (!permissions.some(permission => store.getters['permissions/isSuperAdminHasPermission'](permission))) {
      node.elm.parentElement.removeChild(node.elm)
    }
  },
})
